// как мы это допустили?
export enum IntervalType {
  JustInTime = 'justInTime', // Точно ко времени
  WithinADay = 'withinADay', // В течении дня
  Standard = 'standard', // Стандартная
  Manipulator = 'manipulator', // Манипулятором
  NextNHours = 'nextNHours', // в течении Н часов
  FootCourier = 'footCourier', // пеший курьер
}

export enum IntervalService {
  Unload = 'unload',
  Uplift = 'uplift',
}

export interface OccTime {
  hours: number;
  minutes: number;
}

export interface OccInterval {
  from: OccTime;
  to: OccTime;
}

export interface OccTimeSlot {
  deliveryType: string;
  // в формате YYYY-mm-dd
  formattedDate: string;
  intervalDescription: string;
  intervalType: IntervalType | string;
  intervals: OccInterval[];
  price: number;
  transportIds: string[];
  services: IntervalService[];
}

export interface OccTimeSlots {
  slots: OccTimeSlot[];
}

export interface TimeSlot extends Pick<
  OccTimeSlot,
  'deliveryType' | 'intervalDescription' | 'price' | 'services' | 'transportIds'
> {
  // в формате YYYY-mm-dd
  date: string;
  intervalType: IntervalType;
  interval: string;
  intervalDisplay?: string;
  title?: string;
}

export interface TimeSlots {
  slotListArray: SlotListArray[];
}

export interface SlotListArray {
  // дата слотов в списке
  date: string;

  // Слоты сгруппированные по типам интервалов
  groups: {
    [key in IntervalType]: TimeSlot[];
  };
}
